import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textFixed'
})
export class TextFixedPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    
    if(!value)
      return '';

    let input = value as string; 

    if(input.length > 20)
      return input.substring(0, 20) + '...';

    return input;
  }

}
